import { MappingEmpty } from '@ni/nimble-components/dist/esm/mapping/empty';
import { wrap } from '../../utilities/react-wrapper';

export { type MappingEmpty };
export const NimbleMappingEmpty = wrap(MappingEmpty);
